import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { Text, FlexContainer, Separator } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { TaxReturnTypes } from 'Containers/Result/utils';
import { useGetPreviousYearInfo } from 'Containers/Filing/hooks';
import MaiorDaResult from 'Containers/Result/components/MaiorDaResult';
import PreviousYearResultBanner from 'Containers/Result/components/PreviousYearResultBanner';
import MandatoryInfo from 'Containers/Result/components/MandatoryInfo';
import { ResultType } from 'Types/common';
import { isMaiorDaResultOrEqual } from './utils';

const ResultInfoNotToReturn = ({ data }: { data: ResultType }): JSX.Element => {
  const { t } = useTranslation(locizeNS.RESULT);
  const previousYearInfo = useGetPreviousYearInfo();

  return isMaiorDaResultOrEqual(data, previousYearInfo) && previousYearInfo ? (
    <MaiorDaResult daInfo={data} pyInfo={previousYearInfo} />
  ) : (
    <>
      {data?.mandatory && data.taxReturnType === TaxReturnTypes.TO_PAY ? (
        <>
          <Text type="paragraphs" align="center" size="L_XL_S" color="dark">
            {t('Result.less.title.mandatory.toPay')}
          </Text>
          <FlexContainer direction="column" align="center" gap="dimension_08">
            <Text type="paragraphs" align="center" size="M_L_S" color="dark">
              {t('Result.less.subtitle.mandatory.toPay')}
            </Text>
            <Text type="paragraphs" align="center" size="L_L_S" color="grey">
              {YayoyakiFormatter.formatAmountMxn(Math.abs(data?.taxReturnResult))}
            </Text>
          </FlexContainer>
        </>
      ) : (
        <>
          <Text type="paragraphs" align="center" size="L_XL_S" color="dark">
            {t('Result.less.title', { context: data.taxReturnType })}
          </Text>
          <FlexContainer align="center" direction="column" gap="dimension_08">
            <FlexContainer align="center" gap="dimension_08">
              <Text type="paragraphs" align="center" size="M_L_S" color="dark">
                {t('Result.less.subtitle', {
                  context: data.taxReturnType,
                  amount: YayoyakiFormatter.formatAmountMxn(Math.abs(data?.taxReturnResult)),
                })}
              </Text>
              {data.taxReturnType !== TaxReturnTypes.TO_PAY && (
                <Text type="paragraphs" align="center" size="L_L_S" color="dark">
                  {YayoyakiFormatter.formatAmountMxn(Math.abs(data?.taxReturnResult))}
                </Text>
              )}
            </FlexContainer>
            {data.taxReturnType === TaxReturnTypes.TO_PAY && (
              <Text type="paragraphs" align="center" size="XS_M_S" color="grey">
                {t('Result.less.info.toPay')}
              </Text>
            )}
          </FlexContainer>
        </>
      )}
      <PreviousYearResultBanner data={data} />
      {data.mandatory && (
        <>
          <MandatoryInfo daInfo={data} />
          <Separator />
          <Text type="paragraphs" align="center" size="S_M_S" color="dark">
            {t('Result.less.description', { context: data?.taxReturnType })}
          </Text>
        </>
      )}
    </>
  );
};

export default ResultInfoNotToReturn;
